import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import {
  faSortAmountDown,
  faSortAmountDownAlt,
} from '@fortawesome/pro-solid-svg-icons';

import { useQueryParams } from '@app/hooks';
import { generateRouteParams } from '@app/utils';
import { sortByItemsMessages } from '@app/translations';
import { pageDefaults, SortDirection, SortOption } from '@app/constants';

interface SortUtils {
  sortDirection: SortDirection;
  sortOptions: SortOption[];
  shouldBeReversed: boolean;
  handleSortChange: (option: SortOption) => void;
  getSortedList: <T>(list: T) => T;
}

export const useDashboardListSorting = (): SortUtils => {
  const queryParams = useQueryParams();
  const [sortDirection, setSortDirection] = useState(
    (queryParams.sortDirection as SortDirection) ?? SortDirection.desc
  );
  const navigate = useNavigate();
  const location = useLocation();
  const shouldBeReversed = sortDirection === 'ascending';

  const handleSortChange = option => {
    setSortDirection(option.sortDirection);

    const query = {
      sortDirection: option.sortDirection,
      ...(!isEmpty(queryParams) &&
        queryParams.pageNumber && {
          pageNumber: pageDefaults.pageNumber,
          recordsPerPage: Number(queryParams.recordsPerPage),
        }),
    };

    navigate(
      generateRouteParams({
        pathname: location.pathname,
        query,
      })
    );
  };

  const getSortedList = list => (shouldBeReversed ? [...list].reverse() : list);

  const sortOptions = [
    {
      label: sortByItemsMessages.project,
      sortField: 'name',
      sortDirection: SortDirection.desc,
      icon: faSortAmountDown,
    },
    {
      label: sortByItemsMessages.project,
      sortField: 'name',
      sortDirection: SortDirection.asc,
      icon: faSortAmountDownAlt,
    },
  ];

  return {
    sortDirection,
    sortOptions,
    shouldBeReversed,
    handleSortChange,
    getSortedList,
  };
};
